import { ReactFlowProvider } from "reactflow";
import { Drawer } from "../../components/Drawer";
import OracleFlow from "./OracleFlow";

import "reactflow/dist/base.css";
import styles from "../../../styles/containers/oraculo/oracle-drawer.module.scss";
import { ProgressModal } from "./ProgressModal";

export default ({
  visible,
  boxes = [],
  links = [],
  audience,
  sort,
  limit,
  in_progress,
  disabledVariables = [],
  onClose,
  onQuery,
  onDelete,
}) => {
  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      withoutTransition
      direction="full-center"
      showCloseButton={false}
      alreadyDrawer={audience?.id}
    >
      <div className={styles.oracle} id="oracle-flow">
        <div className={styles.oracleHeader}>
          <div className="d-flex flex-column">
            <p className={styles.title}>
              {audience?.name || "Quem você deseja encontrar?"}
            </p>
            {audience?.id && (
              <p className={styles.subtitle} onClick={onClose}>
                <i className="fas fa-chevron-left" /> Públicos salvos
              </p>
            )}
          </div>
          <div className={styles.close} onClick={onClose}>
            <i className="fas fa-times" />
          </div>
        </div>

        <div className={styles.flow}>
          <ReactFlowProvider>
            <OracleFlow
              boxes={boxes}
              links={links}
              sort={sort}
              limit={limit}
              onClose={onClose}
              onQuery={onQuery}
              onDelete={onDelete}
              audience={audience}
              disabledVariables={disabledVariables}
            />
          </ReactFlowProvider>
        </div>
      </div>

      {in_progress && <ProgressModal />}
    </Drawer>
  );
};
